import { Injectable, inject } from '@angular/core';
import { AssetDto, GalleryDto } from '@nusign/picflow-backend-types';
import { Observable, tap } from 'rxjs';
import { canDisplayAsset } from '../lib/can-display-asset';
import { changeCoverAsset } from '../lib/change-cover-asset';
import { GalleryService } from './gallery.service';
import { UploadService } from './upload.service';

@Injectable({
  providedIn: 'root',
})
export class GalleryUploadService {
  private uploadService = inject(UploadService);
  private galleryService = inject(GalleryService);

  public autoAddTeaserAfterUpload(
    gallery: GalleryDto,
    observable: Observable<{ type: string; data?: { asset?: AssetDto } | object }>
  ) {
    let addedTeaser = !!gallery.teaser?.uuid;
    return observable.pipe(
      tap(async next => {
        if (next.type === 'uploaded' && 'asset' in next.data && next.data.asset?.id) {
          if (!addedTeaser) {
            addedTeaser = true;
            const asset = await this.uploadService.waitForAssetProcessing(next.data.asset.id);
            if (canDisplayAsset(asset)) {
              gallery.teaser = { position: '50% 50%' };
              changeCoverAsset(gallery.teaser, asset);
              this.galleryService.updateGallery(gallery, {
                teaser: gallery.teaser,
              });
            }
          }
        }
      })
    );
  }
}
